import styled from 'styled-components';

const StyledMessage = styled.div``;

export default StyledMessage;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/components/StyledMessage.js